import { bootstrapWidget } from "../../common";
import ReviewsWidget from "./widget";

bootstrapWidget({ widget: ReviewsWidget, widgetType: "reviews" });
